export default {
    applicationName: 'Take care of your vehicle easily and without waiting',
    applicationVersion: 'Version',

    companyLink: 'https://www.drivalia.cz/en/',

    yes: 'Yes',
    no: 'No',

    mapView: 'Map',
    listView: 'List',

    contact: 'Contact',
    contactLink: 'https://www.drivalia.cz/en/contact/',

    servicesLabel: 'Services available in the app',

    maintenanceHeadline: 'Arranging service (maintenance)',
    maintenanceDescription: 'Need to book a regular service, extraordinary service or technical inspection? Select a service center on the map and schedule your appointment online.',

    tiresHeadline: 'Tires',
    tiresDescription: 'Need a tire change? Use the map to find the nearest partner locations and contact them directly to book your appointment.',

    damageHeadline: 'Damage event',
    damageDescription: 'Have you been in an accident or noticed damage to your vehicle? Call us at <a href="tel:+420296333666">+420 296 333 666</a> and we will guide you through the next steps.',

    callingActionHeadline: 'Recall',
    callingActionDescription: 'Have you been contacted about a recall? Choose a service center on the map and book your visit in just a few steps.',

    chargingStationHeadline: 'Charging stations',
    chargingStationDescription: 'Find verified charging stations compatible with Drivalia cards directly on the map. Simply select the one closest to you.',

    blockedLocationServices: 'First enter the address or allow the location services.'
}
